export default __webpack_public_path__ + "static/media/img8.62322f20.PNG";